import { filterUnique, sortByDate } from "../../../shared/common"

const MemesReducer = ( state: any, action: any) => {
  switch (action.type) {
    case 'GET_MEMES':
      return {...state, memes: sortByDate(filterUnique([...state.memes,...action.payload], 'id'), 'created_at')};
    case 'GET_MEME':
      return {...state, meme: action.payload};
    case 'CLEAR_MEME':
      return {...state, meme: {}};
    case 'GET_PHOTOS':
      return {...state, photos: filterUnique([...state.photos,...action.payload], 'id')};
    case 'GET_PHOTO':
      return {...state, photo: action.payload};
    default:
      return state;
  }
};
export default MemesReducer;